/**
 * What: Mounts ShopifySupportPage on the real /support route via the current page wrapper,
 *   following the same pattern as StudySetupsRoute.tsx/StudyBuilderRoute.tsx. ShopifySupportPage's
 *   own content is unchanged — only the outer wrapper moves off the older ShopifyMainPageView.
 */
import type { useAppBridge } from '@shopify/app-bridge-react'
import { ShopifySupportPage } from './ShopifySupportPage'
import { pageTitleForView } from '../shopifyPageCopy'
import type { ShopifyAppViewState } from '../resultsNavigation'

export function SupportRoute({
  appView,
  shopify,
}: {
  appView: Extract<ShopifyAppViewState, { view: 'support' }>
  shopify: ReturnType<typeof useAppBridge>
}) {
  return (
    <s-page heading={pageTitleForView('support')} inlineSize="base">
      <ShopifySupportPage
        shopify={shopify}
        setupId={appView.setupId}
        packetId={appView.packetId}
        runId={appView.runId}
        latestStepKey={appView.latestStepKey}
      />
    </s-page>
  )
}
